var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useGetFileToDownloadQuery } from "@/store/api";
import { usePopup } from "@/hooks/layout";
/** <b>Composant en mode consultation/detail d'un champ de type file</b>*/
export default function FileFieldDetail(_a) {
    var _this = this;
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, moduleName = _a.moduleName;
    var value = useMemo(function () {
        if (!record) {
            return "";
        }
        return record[fieldName || ""] || [];
    }, [fieldName, record]);
    var _b = useState(), dataFile = _b[0], setDataFile = _b[1];
    var values = fieldName === "filename" ? record["document_name"] : value;
    var defaultId = fieldMetadata.type === "image" ? "".concat(record.id, "_photo") : record.id;
    var id = moduleName === "Documents" ? record.document_revision_id : defaultId;
    var _c = useGetFileToDownloadQuery({
        params: {
            id: id,
            type: moduleName,
            isTempFile: false,
            tempName: values,
            isRecordFile: true,
        },
    }), file = _c.data, error = _c.error;
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (error) {
                        throw new Error("error fetching file");
                    }
                    if (file && file.data && file.data.output) {
                        setDataFile(file.data.output);
                    }
                    else {
                        throw new Error("Output URL not found!");
                    }
                }
                catch (error) {
                    console.log("Error:", error);
                }
                return [2 /*return*/];
            });
        }); };
        fetchData();
    }, [file, values, error]);
    var isPhoto = fieldMetadata.type === "image";
    var fileData = record.filecontents && record.filecontents["base64String"];
    var _d = usePopup(), showPopup = _d.showPopup, closePopup = _d.closePopup;
    return (_jsx("div", { children: isPhoto ? (_jsxs("div", __assign({ className: " mb-5" }, { children: [_jsx("img", { src: "".concat(dataFile ? dataFile : "data:image/jpeg;base64,".concat(fileData)), alt: "".concat(values), style: { maxWidth: "20%" } }), _jsx("br", {})] }))) : (_jsx(_Fragment, { children: values && (_jsx("span", __assign({ className: "flex items-center cursor-pointer text-blue-500", onClick: function () {
                    return downloadConfirm(dataFile, values, showPopup, closePopup);
                } }, { children: values }))) })) }));
}
export var downloadConfirm = function (dataFile, values, showPopup, closePopup) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!dataFile) return [3 /*break*/, 2];
                return [4 /*yield*/, showPopup({
                        type: "dev/popup/confirm",
                        payload: {
                            title: "Voulez-vous télécharger le fichier ?",
                            content: " ",
                            buttons: {
                                confirm: "Oui",
                                cancel: "Non",
                            },
                        },
                    })];
            case 1:
                result = _a.sent();
                if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                    forceFileDownload(dataFile, values);
                    closePopup("null", "null");
                }
                else {
                    closePopup("null", "null");
                }
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
function forceFileDownload(output, title) {
    var link = document.createElement("a");
    link.href = output;
    link.download = title;
    link.click();
}
